import { Media, Theme } from '@shared/ui'

enum Pages {
  HOME = '/',

  /* eslint-disable typescript-sort-keys/string-enum */
  PRESS_KIT = '/press-kit/ship-of-fools/',
  /* eslint-enable typescript-sort-keys/string-enum */
}

const EXTERNAL_PAGES: Partial<Record<Pages, string>> = {}

const STATIC_PAGES = [Pages.PRESS_KIT]

export function getSlug(
  page: Pages,
  externalUrls: Record<string, string | null>
) {
  const externalPageKey = EXTERNAL_PAGES[page]

  if (externalPageKey !== undefined) {
    return externalUrls[externalPageKey]
  }

  return page
}

export function getLinks(externalUrls: Record<string, string | null>) {
  return Object.values(Pages)
    .map(page => ({ page, slug: getSlug(page, externalUrls) }))
    .filter(
      (entry): entry is typeof entry & { slug: string } =>
        entry.page !== Pages.HOME && entry.slug != null
    )
    .map(({ page, slug }) => ({
      isExternal: Object.hasOwn(EXTERNAL_PAGES, page),
      isStatic: STATIC_PAGES.includes(page),
      to: slug,
      translationId: `navbar.${page
        .replace(/^\/|\/$/g, '')
        .split('/')
        .join('_')}_link`,
    }))
}

export function getTheme(slug: string, media: Media) {
  switch (slug) {
    case Pages.HOME:
      if (media === Media.MOBILE) {
        return Theme.DARK
      }

      return Theme.TRAILER
    default:
      return Theme.LIGHT
  }
}

export default Pages
